import cmp from './PageNotFound'

export default cmp
